// src/app/guards/public.guard.ts
import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { defaultRouteFor } from '../helpers/user-roles';

export const publicGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return true; // El usuario no está logueado, permite el acceso a las rutas públicas.
  }

  // El usuario está logueado: a su ruta de inicio según rol.
  return router.createUrlTree([defaultRouteFor(authService.userLogged$())]);
};
